import React from 'react';
import { Input } from '../../ui/Input';

interface BrandingForm {
  brandColorPrimary: string;
  brandColorSecondary: string;
}

interface BrandingStepProps {
  form: BrandingForm;
  onChange: (f: BrandingForm) => void;
}

export function BrandingStep({ form, onChange }: BrandingStepProps) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
      <p style={{ fontSize: 'var(--text-sm)', color: 'var(--color-text-muted)' }}>
        Personalizza l'aspetto di LensCRM con i colori del tuo brand.
      </p>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.75rem' }}>
        <div>
          <label style={{ display: 'block', fontSize: 'var(--text-sm)', fontWeight: 500, marginBottom: '0.375rem' }}>
            Colore primario
          </label>
          <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
            <input
              type="color"
              value={form.brandColorPrimary || '#2563eb'}
              onChange={e => onChange({ ...form, brandColorPrimary: e.target.value })}
              style={{ width: 36, height: 36, border: 'none', cursor: 'pointer', borderRadius: 'var(--radius-interactive)' }}
            />
            <Input
              value={form.brandColorPrimary}
              onChange={e => onChange({ ...form, brandColorPrimary: e.target.value })}
              placeholder="#2563eb"
            />
          </div>
        </div>
        <div>
          <label style={{ display: 'block', fontSize: 'var(--text-sm)', fontWeight: 500, marginBottom: '0.375rem' }}>
            Colore secondario
          </label>
          <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
            <input
              type="color"
              value={form.brandColorSecondary || '#7c3aed'}
              onChange={e => onChange({ ...form, brandColorSecondary: e.target.value })}
              style={{ width: 36, height: 36, border: 'none', cursor: 'pointer', borderRadius: 'var(--radius-interactive)' }}
            />
            <Input
              value={form.brandColorSecondary}
              onChange={e => onChange({ ...form, brandColorSecondary: e.target.value })}
              placeholder="#7c3aed"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
